module.exports = __webpack_public_path__ + "static/media/speed-up.b55c44ec.svg";